<template>
  <div class="Maddle" >
    <div class="setwidth">
        <img class="image" src="./Middle/Maddle.png" alt="">
    </div>
    <div  class="Maddletitle  ">
        <img class="image" src="./Middle/title.png" alt="">
    </div>
    <!-- <div class="MaddleF setwidth maddlef" >
        <img src="./Middle/MaddleF.png" alt="">
    </div>
    <div class="MaddleS setwidth maddlef" >
        <img src="./Middle/MaddleS.png" alt="">
    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.Maddle{
    // display:flex;
    // justify-content: center;
    // align-items: center;
    // flex-wrap: wrap;
    background-color: #FFFFFF;
    width: 100%;
    .setwidth{
        width: 100%;
        height: 460px*$sun;
    }
    .maddlef{
        display: flex;
        justify-content: center;
    }
}
.Maddletitle{
    width: 1260px*$sun;
    margin: 50px*$sun auto;
}
.MaddleF{
    padding-bottom: 39px*$sun ;
}
.MaddleS{
    padding-bottom: 50px*$sun ;
}
.image{
    width: 100%;
    height: 100%;
}
</style>
